import { motion } from "framer-motion";
import { useState, useRef, useEffect } from "react";
import { StepProps } from "../../../types/onboarding";
import { useFormDataStore } from "../../../store/formDataStore";
import ZodiacWheel from "../../../components/ZodiacWheel";
import DateInputWrapper from "../../../components/DateWheelPicker/DateInputWrapper";
import Button from "../../../components/common/Button";
import styles from "../OnboardingPage.module.css";
import { getZodiacIndex } from "../../../utils/zodiacUtils";

const StepBirthDate: React.FC<StepProps> = ({ onNext, onBack }) => {
  const { formData, setFormData } = useFormDataStore();
  const [zodiac, setZodiac] = useState("");
  const [dateString, setDateString] = useState("");
  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleDateSelect = (date: Date, zodiacSign: string) => {
    // ✅ Формируем YYYY-MM-DD вручную, избегая смещения времени в toISOString()
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const formatted = `${year}-${month}-${day}`;

    setFormData({ birthDate: formatted });
    setZodiac(zodiacSign);
    setDateString(date.toLocaleDateString("ru-RU"));
  };

  useEffect(() => {
    if (formData.birthDate) {
      buttonRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [formData.birthDate]);

  return (
    <motion.div
      key="step-birth-date"
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -100 }}
    >
      <h2>Дата рождения</h2>
      <p>Выберите свою дату рождения. Это поможет определить ваш знак зодиака.</p>

      <ZodiacWheel activeIndex={zodiac ? getZodiacIndex(zodiac) : undefined} />

      <DateInputWrapper value={dateString} onChange={handleDateSelect} context="onboarding" />

      <div className={`${styles["button-row"]} ${styles["two-buttons"]}`}>
        <Button onClick={onBack}>Назад</Button>
        <Button ref={buttonRef} onClick={onNext} disabled={!formData.birthDate}>
          Далее
        </Button>
      </div>
    </motion.div>
  );
};

export default StepBirthDate;
